import { type INode } from '@shared/lib/ris.types'
import { type FunctionComponent } from 'react'

const Fallback: FunctionComponent<INode> = function Fallback (props) {
  return (
    <pre style={{ overflow: 'scroll' }}>
      {JSON.stringify(props, null, 2)}
    </pre>
  )
}

export default Fallback
